import { Product } from '@interfaces/models/product';
import React from 'react';
import clsx from 'clsx';
import styles from './hero-pdp-product-details.module.scss';

export type HeroPDPProductDetailsProps = {
  product: Product;
  customClass?: string;
};

const HeroPDPProductDetails: React.FC<HeroPDPProductDetailsProps> = (props): React.JSX.Element => {
  const { product, customClass } = props;

  return (
    <div className={clsx(styles.heroPDPProductDetails, customClass ?? '')}>
      {!!product.size && (
        <p
          className={clsx(
            styles.heroPDPProductDetails__description,
            styles['heroPDPProductDetails__description--size'],
          )}
          data-cy="hero_pdp_product_details_size"
        >
          {product?.size.size}
          {product.size.localizedStandard && (
            <span
              className={styles.heroPDPProductDetails__guideStandard}
              data-cy="hero_pdp_product_details_size_standard"
            >
              {product.size.localizedStandard}
            </span>
          )}
        </p>
      )}
      <p
        className={styles.heroPDPProductDetails__description}
        data-cy="hero_pdp_product_details_condition"
      >
        {product?.condition?.description}
      </p>
      <p
        className={styles.heroPDPProductDetails__description}
        data-cy="hero_pdp_product_details_color_material"
      >
        {product?.color?.localizedName}, {product?.material?.localizedName}
      </p>
    </div>
  );
};

export default HeroPDPProductDetails;
